import React from "react";

export default function IconStar() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8422 3.29125C14.2422 2.23625 15.756 2.23625 16.1572 3.29125L18.7447 10.4587C18.835 10.6922 18.994 10.8929 19.2006 11.0341C19.4073 11.1754 19.6519 11.2507 19.9022 11.25H26.261C27.436 11.25 27.9485 12.7125 27.0247 13.4288L22.4997 17.5C22.297 17.6558 22.1489 17.8718 22.0766 18.1171C22.0043 18.3623 22.0115 18.6241 22.0972 18.865L23.7497 25.8687C24.1522 26.9937 22.8497 27.96 21.8647 27.2675L15.7185 23.3675C15.508 23.2196 15.257 23.1402 14.9997 23.1402C14.7425 23.1402 14.4915 23.2196 14.281 23.3675L8.13473 27.2675C7.15098 27.96 5.84723 26.9925 6.24973 25.8687L7.90223 18.865C7.98795 18.6241 7.99518 18.3623 7.92287 18.1171C7.85055 17.8718 7.70243 17.6558 7.49973 17.5L2.97473 13.4288C2.04973 12.7125 2.56473 11.25 3.73723 11.25H10.096C10.3463 11.2508 10.5911 11.1756 10.7978 11.0343C11.0044 10.893 11.1634 10.6923 11.2535 10.4587L13.841 3.29125H13.8422Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
